import {Component, OnInit} from '@angular/core';
import {Roteiro} from '../../comum/modelos/roteiro';
import {Paginacao} from '../../comum/modelos/paginacao';
import {RoteiroService} from '../roteiro.service';
import {Evento} from '../../comum/eventos/evento';
import {ComumService} from '../../comum/comum.service';
import {RotinaCliente} from '../../comum/modelos/rotina-cliente';
import {ActivatedRoute} from '@angular/router';
import { AuthService } from '../../auth/auth.service';

@Component({
  selector: 'app-selecao-roteiros-usuario',
  templateUrl: './listar-roteiros-usuario.component.html',
  styleUrls: ['./listar-roteiros-usuario.component.css']
})
export class ListarRoteirosUsuarioComponent implements OnInit {

  filtroPesquisaNomeRoteiro: string;

  roteiros: Roteiro[];

  paginacao: Paginacao;

  evento: Evento;

  public loading = false;

  constructor(private _roteiroService: RoteiroService,
    private _activatedRoute: ActivatedRoute,
    private _comumService: ComumService,
    private _authService: AuthService) {
    this.paginacao = new Paginacao();

    this.roteiros = new Array<Roteiro>();
    this.evento = this._comumService.evento;

    if (this.evento !== undefined) {
      setTimeout(() => {this._comumService.cleanEvent(); }, 2000);
    }

  }

  ngOnInit() {
    this.paginacao.itens = 5;
    this.paginacao.page = 1;
    this.loading = true;

    const id = this._activatedRoute.snapshot.params['id'];
    this._roteiroService.obterRoteirosUsuarioHttp(id)
      .subscribe((roteiros: Roteiro[]) => {
        this.roteiros = roteiros;
        this.loading = false;
      });
  }

  pesquisarPorFiltro(filtro: any): void {
    this.filtroPesquisaNomeRoteiro = filtro.value;
  }

  limparPesquisaPorFiltro(filtro: any): void {
    filtro.value = '';
    this.pesquisarPorFiltro(filtro);
  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/roteiro/listar-roteiros-usuario/listar-roteiros-usuario.component.ts